import { useHistory } from 'react-router-dom';
import Breadcrumbs, { BreadcrumbsItem } from '../../template/MainTheme/components/Breadcrumbs';
import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
import { ClientDataForm, ClientFilters } from '../../app/models/Client';

import DefaultCard from '../../components/default/DefaultCard';
import ButtonCreate from '../../components/buttons/ButtonCreate';

import { ServiceResponse } from '../../app/services/shared/interfaces';
import useClientService from '../../app/services/hooks/useClientService';
import DefaultModal from '../../components/default/DefaultModal';
import ClientCreate from './components/ClientCreate';
import ClientEdit from './components/ClientEdit';
import { AppContext } from '../../contexts/AppContext';
import useReactConfirmAlert from '../../hooks/useReactConfirmAlert';
import ClientDataTable from './components/tables/ClientDataTable';
import { toast } from 'react-toastify';
import useNavigationPage from '../../hooks/useNavigationPage';

const breadcrumbs: BreadcrumbsItem[] = [
    {
        name: 'Clientes',
        url: '/clients',
        isActive: true
    }
];

const Client = () => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const history = useHistory();
    const { fetchingGetClients, getClients, deleteClient, activeClient } = useClientService();

    const { auth } = useContext(AuthContext);

    const [clientIdEdit, setClientIdEdit] = useState<number>(-1);
    const [showingEdit, setShowingEdit] = useState(false);
    const [clients, setClients] = useState<ClientDataForm[]>([]);
    const [totalRows, setTotalRows] = useState(0);
    const { navigationPage } = useNavigationPage();

    const [showingCreate, setShowingCreate] = useState(false);

    const [filter, setFilter] = useState<ClientFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc',
        rut: '',
        business_name: ''
    });

    useEffect(() => {
        reloadTable();
    }, [filter.page, filter.per_page, filter.sort, filter.order]);

    const reloadTable = () => {
        getClients(filter, {
            onSuccess: (response: ServiceResponse) => {
                setClients(response.data.clients);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
                if (response.data.to_dashboard) {
                    navigationPage('/');
                }
            }
        });
    };

    const showCreate = () => {
        setShowingCreate(true);
    };

    const hideCreate = () => {
        setShowingCreate(false);
    };

    const showEdit = (ClientId: number) => {
        setShowingEdit(true);
        setClientIdEdit(ClientId);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setClientIdEdit(-1);
    };

    const onError = () => {
        setShowingEdit(false);
        setClientIdEdit(-1);
    };

    const active = (carrierId: number, active: boolean) => {
        activeClient(carrierId, active, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                reloadTable();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    const destroy = (clientId: number) => {
        const _text = 'Está a punto de eliminar el cliente #' + clientId;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, confirmar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Eliminando cliente...');
                        deleteClient(clientId, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();
                                // useSweetAlert().successAlert({
                                //     title: 'Éxito',
                                //     text: response.message

                                // });
                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });
                                // if(changeAnimation)changeAnimation('success', response.message, true);
                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El cliente no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    {
        /*const active = (clientId: number, active: boolean) => {*/
    }
    //                     activeClient(clientId, active, {
    //                         onSuccess: (response: ServiceResponse) => {
    //                             if (hideLoading) hideLoading();
    //                             // useSweetAlert().successAlert({
    //                             //     title: 'Éxito',
    //                             //     text: response.message
    //
    {
        /*                            // });*/
    }
    {
        /*                            useReactConfirmAlert().successAlert({*/
    }
    //                                 title: 'Éxito',
    //                                 message: response.message
    //                             });
    //                             // if(changeAnimation)changeAnimation('success', response.message, true);
    {
        /*                            reloadTable();*/
    }
    {
        /*                        },*/
    }
    {
        /*                        onError: (response: ServiceResponse) => {*/
    }
    {
        /*                            if (hideLoading) hideLoading();*/
    }

    //                             useReactConfirmAlert().errorAlert({
    //                                 title: 'Error',
    //                                 message: response.message
    //                             });
    //                         }
    //                     });
    //
    //
    // };

    return (
        <>
            <Breadcrumbs pageSection="Clientes" breadcrumbs={breadcrumbs} />
            <DefaultCard>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col">
                                <ButtonCreate callbackCreate={showCreate} title="Nuevo cliente" />
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <ClientDataTable
                            active={active}
                            clients={clients}
                            totalRows={totalRows}
                            loading={fetchingGetClients}
                            destroy={destroy}
                            edit={showEdit}
                            filter={filter}
                            setFilter={setFilter}
                            callbackSuccess={reloadTable}
                            onSearch={reloadTable}
                        />
                    </div>
                </div>
            </DefaultCard>
            {showingCreate ? (
                <DefaultModal
                    show={showingCreate}
                    handleClose={hideCreate}
                    title="Crear cliente"
                    backdrop={true}
                    showFooter={false}
                >
                    <ClientCreate
                        onSaved={() => {
                            reloadTable();
                            hideCreate();
                        }}
                        onCancel={hideCreate}
                        onError={hideCreate}
                    />
                </DefaultModal>
            ) : null}

            {showingEdit ? (
                <DefaultModal
                    show={showingEdit}
                    handleClose={hideEdit}
                    title="Editar Cliente"
                    backdrop={true}
                    showFooter={false}
                >
                    <ClientEdit
                        clientId={clientIdEdit}
                        onSaved={() => {
                            reloadTable();
                            hideEdit();
                        }}
                        onCancel={hideEdit}
                        onError={onError}
                    />
                </DefaultModal>
            ) : null}
        </>
    );
};

export default Client;
